import React from 'react';
import { Route, Switch } from 'react-router-dom';
import DefaultLayout from './layouts/DefaultLayout';
import Dashboard from './pages/dashboard/Dashboard';
import TwoFaCallBack from './pages/dashboard/TwoFaCallBack';
import TwoFaNotVerifiedCallBack from './pages/dashboard/TwoFaNotVerifiedCallBack';
import Login from './pages/login/Login';
import Logout from './pages/logout/Logout';
import PaymentCallback from './pages/paymentCallback/PaymentCallback';
import PaymentCancel from './pages/dashboard/PaymentCancel';
import TattoistForm from "./navigation/TattoistForm";
import TattooOperatorForm from "./navigation/TattooOperator";
import { Timer } from "./components/common/timer/Timer";
import CheckApiRequests from "./CheckApiRequests";

const App = props => (
  <CheckApiRequests>
       <Timer>
              <Switch>
                     <Route path="/payment/success" exact component={() => PaymentCallback(props)} />
                     <Route path="/login" exact
                            component={() => Login(props)} />
                     <Route path="/logout" exact
                            component={() => Logout(props)} />
                     <Route path="/payment/success" exact
                            component={() => PaymentCallback(props)} />
                     <Route path="/payment/cancel" exact component={() => <DefaultLayout><PaymentCancel /></DefaultLayout>} />
                     <Route path="/" exact
                            component={() => <DefaultLayout><Dashboard /></DefaultLayout>} />
                     <Route path="/servicecompletionreference/:id" exact
                            component={() => <DefaultLayout><TwoFaCallBack /></DefaultLayout>} />
                     <Route path="/servicereference/:id" exact
                            component={() => <DefaultLayout><TwoFaNotVerifiedCallBack /></DefaultLayout>} />
                     <>
                            <TattoistForm />
                            <TattooOperatorForm />
                     </>
              </Switch>
       </Timer>
  </CheckApiRequests>
);

// export default CheckApiRequests(App);
export default App;
